import { initIdentity } from 'astro-decap-cms/identity-widget'; initIdentity('/admin');